if (jQuery('body').hasClass('logged-in')) {
    jQuery('.myAccount .sub-menu').addClass('isVisible');
}

if (!jQuery('body').hasClass('logged-in')) {
    jQuery( ".myAccount" ).on('click', function() {
        jQuery('#qodef-membership-login-modal').addClass('qodef--opened');
    });
}
